import React from 'react';
import AppRoute from './components/Route';

function App() {
  return <AppRoute />;
}

export default App;


